import '@cfg/cfg-utilities-fe/dist/cfg-utilities-fe.css';
import VueGtm from '@gtm-support/vue2-gtm';
import { Integrations } from '@sentry/tracing';
import * as Sentry from '@sentry/vue';
import moment from 'moment';
import Vue from 'vue';
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import vuetify from '@/plugins/vuetify';
import { moneyNumberFormat } from '@/helpers/functions';
import i18n from '@/plugins/i18n';
import router from '@/router';
import store from '@/store';
import App from '@/App.vue';
import '@/assets/scss/global.scss';
import '@/assets/tailwind.css';
import { truncate } from 'lodash';

Vue.config.productionTip = false;

// TOASTER
Vue.use(Toast, { timeout: 2000 });

// VUETIFY
Vue.use(VueTelInputVuetify, { vuetify });

// VUE FILTERS
Vue.filter('currency', (value: string) => moneyNumberFormat(+value ?? 0));
Vue.filter('truncate', (value: string) => truncate(value));

// MOMENT
Vue.prototype.moment = moment;
Vue.prototype.moment.locale('cs-CZ');

// SENTRY
if (['production', 'stage', 'dev'].includes(process.env.VUE_APP_ENVIRONMENT)) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN || '',
    environment: process.env.VUE_APP_ENVIRONMENT,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    trackComponents: true,
    logErrors: true,
    tracesSampleRate: 1.0,
  });
}

// GOOGLE TAG MANAGER
if (process.env.VUE_APP_GTM_ID) {
  const queryParams = ['dev', 'local'].includes(process.env.VUE_APP_ENVIRONMENT)
    ? { gtm_auth: process.env.VUE_APP_GTM_AUTH, gtm_preview: process.env.VUE_APP_GTM_ENV }
    : {};

  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GTM_ID,
    queryParams,
    debug: ['dev', 'local'].includes(process.env.VUE_APP_ENVIRONMENT),
    vueRouter: router,
  });
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
